<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'sm'"
    :modal-id="'reject-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <b-form @submit.prevent="$emit('onReject', formData)">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header">Reject</div>
        </div>
      </div>
      <div class="modal-wrp mx-3"></div>

      <b-row class="d-flex justify-content-center px-2">
        <b-col cols="10">
          <b-form-group
            :label="'Reject Reason'"
            label-for="reject-reason"
            label-class="font-medium-5"
          >
            <v-select
              v-model="formData.reJectId"
              :reduce="(option) => option.value"
              class="select-format-container font-medium-5 bg-dropdown"
              :options="OptionReject"
              :clearable="false"
              :placeholder="'เลือกเหตุผลที่ Reject'"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1 d-flex justify-content-center px-2" v-if="formData.reJectId == 0">
        <b-col cols="10">
          <b-form-group
            :label="'Reason'"
            label-for="rejectReason"
            label-class="font-medium-5 required"
          >
            <b-form-input id="rejectReason" v-model="formData.rejectReason" required placeholder="ระบุ"/>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1 btn-reject-modal btn-cancel"
                @click.native="$emit('onCloseModal')"
              />
              <save-button class="ml-1 btn-reject-modal btn-save" type="submit" />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue";
import Textbox from "@/views/components/dynamic-fields/components/TextBoxField.vue";
import TextAreaField from "@/views/components/dynamic-fields/components/TextAreaField.vue";
import Dropdown from "@/views/components/dynamic-fields/components/DropdownField.vue";
import DatePicker from "@/views/components/dynamic-fields/components/DatePickerField.vue";
import { reactive } from "@vue/composition-api";

export default {
  components: {
    Toggle,
    Textbox,
    TextAreaField,
    Dropdown,
    DatePicker,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: Object, default: {} },
    OptionReject: { type: Array, default: [] },
  },
  setup() {
    const formData = reactive({
      rejectReason: "",
    });

    return {
      formData,
    };
  },
};
</script>

<style>

</style>
